import { useQuery } from '@tanstack/react-query'
import { rentalsAPI } from '../services/api'

export const useRentals = ({
  page = 1,
  limit = 25,
  search = '',
  status = 'all',
  country = 'all',
  service = 'all',
  dateFrom = null,
  dateTo = null,
  sortBy = 'created_at',
  sortOrder = 'desc'
} = {}) => {
  return useQuery({
    queryKey: ['admin', 'rentals', { page, limit, search, status, country, service, dateFrom, dateTo, sortBy, sortOrder }],
    queryFn: async () => {
      const params = {
        page,
        limit,
        sortBy,
        sortOrder
      }

      if (search) params.search = search
      if (status !== 'all') params.status = status
      if (country !== 'all') params.country = country
      if (service !== 'all') params.service = service
      if (dateFrom) params.dateFrom = dateFrom
      if (dateTo) params.dateTo = dateTo

      const response = await rentalsAPI.getRentals(params)
      return response.data.data
    },
    staleTime: 30000, // 30 seconds
    refetchOnWindowFocus: false,
  })
}

export const useRentalDetails = (rentalId, options = {}) => {
  return useQuery({
    queryKey: ['admin', 'rental-details', rentalId],
    queryFn: async () => {
      if (!rentalId) {
        throw new Error('Rental ID is required')
      }

      const response = await rentalsAPI.getRentalDetails(rentalId)
      return response.data.data
    },
    enabled: !!rentalId && options.enabled !== false,
    staleTime: 30000,
    refetchOnWindowFocus: false,
    ...options,
  })
}
